<h1 mat-dialog-title>{{ data?.item ? ucFirst(data.itemLabel) + ' bewerken' : 'Nieuw ' + data.itemLabel }}</h1>
@if (!loading()) {
  <mat-dialog-content>
    <form (ngSubmit)="save()" [formGroup]="form">
      <ng-template #fieldTemplate let-field>
        @if (isFieldVisible(field)) {
          @if (
            field.type === 'string' || field.type === 'numberInput' || field.type === 'order' || field.type === 'phone'
          ) {
            <mat-form-field>
              <mat-label>{{ field.label }}</mat-label>
              <input
                placeholder="{{ field.label }}"
                formControlName="{{ field.key }}"
                autocomplete="off"
                type="text"
                matInput
              />
              @if (form.controls[field.key].errors) {
                <mat-error>{{ getError(field.key) }}</mat-error>
              }
            </mat-form-field>
          } @else if (field.type === 'addressAutocomplete') {
            <app-ors-address-autocomplete
              [formControlName]="field.key"
              [label]="field.label"
              [placeholder]="field.label"
              [required]="true"
              [autoActiveFirstOption]="true"
            ></app-ors-address-autocomplete>
          } @else if (field.type === 'number') {
            <mat-form-field>
              <mat-label>{{ field.label }}</mat-label>
              <input
                placeholder="{{ field.label }}"
                formControlName="{{ field.key }}"
                autocomplete="off"
                type="number"
                [min]="field.min ?? null"
                matInput
              />
              @if (form.controls[field.key].errors) {
                <mat-error>{{ getError(field.key) }}</mat-error>
              }
            </mat-form-field>
          } @else if (field.type === 'toggle') {
            <mat-slide-toggle formControlName="{{ field.key }}">{{ field.label }}</mat-slide-toggle>
          } @else if (field.type === 'select') {
            <mat-form-field>
              <mat-label>{{ field.label }}</mat-label>
              <mat-select [formControlName]="field.key">
                @if (field.searchable) {
                  <mat-option>
                    <ngx-mat-select-search
                      [formControl]="selectSearchControls[field.key]"
                      placeholderLabel="Zoeken"
                      noEntriesFoundLabel="Geen resultaten gevonden"
                    ></ngx-mat-select-search>
                  </mat-option>
                }
                @for (option of filteredSelectOptions[field.key] ?? field.group ?? []; track option.id) {
                  <mat-option [value]="option.id">{{ option.name }}</mat-option>
                }
              </mat-select>
              @if (form.controls[field.key].errors) {
                <mat-error>{{ getError(field.key) }}</mat-error>
              }
            </mat-form-field>
          } @else if (field.type === 'color') {
            <mat-form-field>
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                placeholder="#efefef"
                readonly="true"
                formControlName="{{ field.key }}"
                #ignoredInput
                [cpIgnoredElements]="[ignoredButton, ignoredInput]"
                [colorPicker]="form.controls[field.key].value"
                (colorPickerChange)="form.controls[field.key].setValue($event)"
                [cpToggle]="colorPickers[field.key]"
                (cpToggleChange)="colorPickers[field.key] = $event"
                [cpAlphaChannel]="'disabled'"
                [cpOKButton]="true"
                [cpPosition]="data.fields.indexOf(field) <= 3 ? 'bottom' : 'top'"
                [cpCancelButton]="true"
                [cpCancelButtonText]="'Annuleren'"
              />
              <button
                matSuffix
                mat-icon-button
                aria-label="Kleurkiezer openen"
                #ignoredButton
                type="button"
                (click)="colorPickers[field.key] = !colorPickers[field.key]"
              >
                <mat-icon
                  [ngStyle]="{
                    color: form.value[field.key],
                  }"
                  >circle
                </mat-icon>
              </button>
              @if (form.controls[field.key].errors) {
                <mat-error>{{ getError(field.key) }}</mat-error>
              }
            </mat-form-field>
          } @else if (field.type === 'checkboxGroup') {
            <div class="checkbox-group">
              @for (item of field.group; track item.id) {
                <mat-checkbox
                  class="group-checkbox"
                  (change)="groupItemChange($event, field.key, item.id)"
                  [checked]="checked(item.id, field.key)"
                  >{{ item.name }}
                </mat-checkbox>
              }
            </div>
          } @else if (field.type === 'iconGroup') {
            <div class="icons">
              @for (icon of field.group; track icon.id) {
                <div
                  class="icon"
                  role="button"
                  tabindex="0"
                  [ngClass]="{ active: form.value[field.key].includes(icon.id) }"
                  [attr.aria-label]="
                    form.value[field.key].includes(icon.id)
                      ? 'Bijzonderheid deselecteren: ' + icon.name
                      : 'Bijzonderheid selecteren: ' + icon.name
                  "
                  [attr.aria-pressed]="form.value[field.key].includes(icon.id)"
                  [matTooltip]="icon.name"
                  (click)="iconItemChange(field.key, icon.id)"
                  (keydown.enter)="iconItemChange(field.key, icon.id)"
                  (keydown.space)="$event.preventDefault(); iconItemChange(field.key, icon.id)"
                >
                  <mat-icon [svgIcon]="icon.id"></mat-icon>
                </div>
              }
            </div>
          }
        }
      </ng-template>
      @if (hasFieldRows()) {
        <div class="vehicle-fields">
          @for (group of getFieldRenderGroups(); track $index) {
            @if (group.row) {
              <div
                class="vehicle-field-row"
                [class.vehicle-field-row-icons]="group.fields.length === 1 && group.fields[0].type === 'iconGroup'"
                [class.vehicle-field-row-three]="group.fields.length === 3"
              >
                @for (field of group.fields; track field.key) {
                  <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field }"></ng-container>
                }
              </div>
            } @else {
              @for (field of group.fields; track field.key) {
                <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field }"></ng-container>
              }
            }
          }
        </div>
      } @else {
        @for (field of data.fields; track field.key) {
          <ng-container *ngTemplateOutlet="fieldTemplate; context: { $implicit: field }"></ng-container>
        }
      }
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" mat-dialog-close>Annuleren</button>
    <button
      mat-flat-button
      type="submit"
      (click)="save()"
      [class.spinner]="saving()"
      [disabled]="form.invalid || saving()"
    >
      Opslaan
    </button>
  </mat-dialog-actions>
}
